cockpitApp.directive('flightBodyDetailsAdditional', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/flight/body/details-additional',
    controllerAs: 'flightBodyDetailsAdditionalCtrl',
    controller: 'flightBodyDetailsAdditionalController'
  };
});
